module.exports = __webpack_public_path__ + "img/yan11.857aaf0d.png";